import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ENTERPRISE_DEMO_IEAM_4 = {
  title: "View and manage \n deployed applications",
  subtitle: "Enterprise demo",
  text: "The enterprise customer has full view of \n installed applications and can enable or disable\n the deployment with a single click. ",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_115"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_113"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_01.png",
  rightSideImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_04.png",
};
